import React, { FC, useEffect, useRef, useState } from 'react';
import SuccessToast from '../../../cards/toast';
import { useTranslate } from '@tolgee/react';
import { relocatePublishButtons } from '../../../utils/uploadMediaFile';
import { PLATFORM_COLORS, PLATFORM_ICONS } from '../../../../../config/icons';
import { INSTAGRAM } from '../../../../../config/constants';
import { VIDEO } from '../../../config/constants';
import { lomavisCreatorRootState } from '../../../../../pages/lomavisCreator';
import { useSelector } from 'react-redux';
import Tagger from './Tagger';
import IGCarousel from './aside';
import { Button } from 'react-bootstrap';
import { EditorHeader } from '../../sharedComponents';
import { cropImage } from '../../../../../utils/media/cropImage';

interface Props {
  handleClose: Function;
}
const IGTags: FC<Props> = ({ handleClose }) => {
  const { t } = useTranslate();
  const footerRef = useRef(null);
  const submitRef = useRef(null);
  const saveBtnRef = useRef(null);

  const [rightMargin, setRightMargin] = useState(0);

  const [showToast, setShowToast] = useState(false);
  const [startSubmission, setStartSubmission] = useState(false);

  let postDataIGMediaFiles = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[INSTAGRAM]?.media
  );

  const postDataIGCropList = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[INSTAGRAM]?.cropList
  );

  const instagramUserTags = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[INSTAGRAM]?.instagram_temp_tags
  );
  const [isProcessingMedia, setIsProcessingMedia] = useState(true);

  const [updatedIGMediaFiles, setUpdatedIGMediaFiles] =
    useState(postDataIGMediaFiles);
  const [editorChanged, setEditorChanged] = useState(false);
  const [selectedIGfile, setSelectedIGfile] = useState(updatedIGMediaFiles[0]);

  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  const [selectedIGTagObject, setselectedIGTagObject] = useState(
    instagramUserTags?.find((obj) => obj.uuid === selectedIGfile?.uuid)
  );
  const [croppedImageUrl, setCroppedImageUrl] = useState('');

  const { postData } = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );
  const crop = (postData[INSTAGRAM]?.cropList || []).find(
    (crop) => crop.uuid === selectedIGfile?.uuid
  );

  const getTaggablePreviewSrc = (file) => {
    if (!file) return '';
    if (file.media_type === VIDEO) {
      return (
        file?.thumbnail_image ||
        file?.preview_image ||
        file?.assetBlob ||
        file?.original_asset ||
        ''
      );
    }
    return file?.preview_image || file?.assetBlob || file?.original_asset || '';
  };

  const returnSrcImage = async () => {
    if (!selectedIGfile) {
      setCroppedImageUrl('');
      return;
    }

    if (selectedIGfile?.media_type === VIDEO) {
      setCroppedImageUrl(getTaggablePreviewSrc(selectedIGfile));
      return;
    }

    if (crop) {
      try {
        const croppedImageUrl = await cropImage(
          getTaggablePreviewSrc(selectedIGfile),
          crop
        );
        setCroppedImageUrl(croppedImageUrl);
      } catch (error) {
        setCroppedImageUrl(getTaggablePreviewSrc(selectedIGfile));
      }
    } else {
      setCroppedImageUrl(getTaggablePreviewSrc(selectedIGfile));
    }
  };
  useEffect(() => {
    returnSrcImage();
  }, [selectedIGfile, crop]);

  const triggerToast = () => {
    setShowToast(true);
  };

  useEffect(() => {
    (async () => {
      setIsProcessingMedia(true);
      const updatedMediaFiles = [...postDataIGMediaFiles]; // clone

      for (const [index, mediaFile] of updatedMediaFiles.entries()) {
        if (mediaFile?.media_type === VIDEO) {
          updatedMediaFiles[index] = {
            ...mediaFile,
            preview_image: getTaggablePreviewSrc(mediaFile)
          };
          continue;
        }

        const crop = (postDataIGCropList || []).find(
          (crop) => crop.uuid === mediaFile?.uuid
        );

        if (crop) {
          const image = new Image();
          image.src = mediaFile?.assetBlob || mediaFile?.original_asset;

          await new Promise((resolve) => {
            image.onload = resolve;
          });

          const imageWidth = image.width;
          const scaleFactor = imageWidth / mediaFile.width;

          const newCrop = {
            x: crop.x * scaleFactor,
            y: crop.y * scaleFactor,
            width: crop.width * scaleFactor,
            height: crop.height * scaleFactor
          };

          const croppedImageUrl = await cropImage(
            mediaFile.original_asset,
            newCrop
          );

          // Replace values in the cloned array

          updatedMediaFiles[index] = {
            ...mediaFile,
            assetBlob: croppedImageUrl,
            preview_image: croppedImageUrl
          };
        }
      }

      // Dispatch updated array back to Redux
      setUpdatedIGMediaFiles(updatedMediaFiles);
      setSelectedIGfile(updatedMediaFiles[0]);
      setIsProcessingMedia(false);
    })();
  }, [postDataIGMediaFiles]);

  useEffect(() => {
    relocatePublishButtons({
      footerRef: footerRef,
      setRightMargin: setRightMargin
    });
  }, []);
  return (
    <div className="d-flex flex-column w-100 h-100 gap-4 overflow-hidden">
      <SuccessToast show={showToast} onClose={() => setShowToast(false)} />

      <EditorHeader>
        <div
          style={{}}
          className="d-flex justify-content-between align-items-center flex-fill h-100 main_editor"
        >
          <div
            style={{}}
            className="d-flex align-items-center flex-fill h-100 gap-2"
          >
            <i
              className={
                PLATFORM_ICONS[INSTAGRAM] + ' fs-1 d-flex align-items-center'
              }
              style={{ color: PLATFORM_COLORS[INSTAGRAM], fontSize: '32px' }}
            ></i>

            <h4 className=" h-100 d-flex align-items-center mt-2">
              {t('lomavisCreator.IGTag.header')}
            </h4>
          </div>
        </div>
      </EditorHeader>

      <div
        style={{ minHeight: 0 }}
        className="d-flex w-100 gap-4 flex-grow-1 overflow-hidden"
      >
        <div
          style={{ width: '140px' }}
          className="bg-white p-2 rounded-3 mx-auto d-flex flex-column h-100 overflow-hidden flex-shrink-0"
        >
          {' '}
          <IGCarousel
            items={updatedIGMediaFiles}
            setSelectedFile={setSelectedIGfile}
            selectedFile={selectedIGfile}
            instagramUserTags={instagramUserTags}
            setCurrentFileIndex={setCurrentFileIndex}
            editorChanged={editorChanged}
            setEditorChanged={setEditorChanged}
          />
        </div>

        <Tagger
          selectedFile={selectedIGfile}
          croppedImageUrl={croppedImageUrl}
          saveBtnRef={saveBtnRef}
          handleClose={handleClose}
          startSubmission={startSubmission}
          setStartSubmission={setStartSubmission}
          setSelectedFile={setSelectedIGfile}
          instagramUserTags={instagramUserTags}
          currentFileIndex={currentFileIndex}
          editorChanged={editorChanged}
          setEditorChanged={setEditorChanged}
          submitRef={submitRef}
        />
      </div>
      <div
        ref={footerRef}
        style={{ bottom: '0', zIndex: 100, height: '60px', flexShrink: 0 }}
        className="w-100 d-flex justify-content-end gap-3 rounded-3 align-items-center bg-white py-2 px-3 border-top h-60px bg-white"
      >
        <div
          style={{ marginRight: rightMargin + 'px' }}
          className="d-flex justify-content-end gap-3 align-items-center py-2 flax-fill"
        >
          {!startSubmission && (
            <Button
              onClick={() => {
                handleClose();
              }}
              variant="secondary"
              size="sm"
              disabled={startSubmission}
            >
              {t('lomavisCreator.back')}
            </Button>
          )}

          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              submitRef.current?.click();
            }}
            disabled={startSubmission}
          >
            {startSubmission && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {startSubmission
              ? t('lomavisCreator.buttons.saving')
              : t('lomavisCreator.buttons.save')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IGTags;
